import { useState } from "react";
import { Heart, Loader2, ArrowRight } from "lucide-react";
import { api, apiError } from "@/lib/api";
import { useT } from "@/lib/i18n";

const PRESETS = [["donation_1", "$1"], ["donation_3", "$3"], ["donation_5", "$5"]];
export const DONATE_SEEN = "fhp-donate-step";

// Optional donation shown before the create-account form.
export function DonateStep({ onSkip, skipLabel = "Skip — create my account", onSkipBack = false }) {
  const t = useT();
  const [pick, setPick] = useState("donation_3");
  const [own, setOwn] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const dollars = parseInt(own, 10);
  const give = async () => {
    const body = pick === "own" ? { dollars } : { lookup_key: pick };
    if (pick === "own" && !(dollars >= 1 && dollars <= 500)) { setErr(t("Enter a whole dollar amount from $1 to $500.")); return; }
    setBusy(true); setErr("");
    try { sessionStorage.setItem(DONATE_SEEN, "1"); window.location.href = (await api.donate(body)).checkout_url; }
    catch (e) { setErr(apiError(e) || t("Couldn't start checkout. Try again.")); setBusy(false); }
  };
  return (
    <div className="card donate-card" data-testid="donate-step">
      <div className="donate-head"><Heart size={18} className="donate-heart" /><b>{t("Keep Fuel Hauler Pro free")}</b></div>
      <div className="card-sub">{t("Every feature is free for every driver. If the app helps you, a small donation keeps the servers and photo readers running.")}</div>
      <div className="seg donate-amounts" data-testid="donate-amounts">
        {PRESETS.map(([k, l]) => <button key={k} type="button" className={pick === k ? "seg-on" : ""} onClick={() => setPick(k)} data-testid={`donate-${k}`}>{l}</button>)}
        <button type="button" className={pick === "own" ? "seg-on" : ""} onClick={() => setPick("own")} data-testid="donate-own">{t("Other")}</button>
      </div>
      {pick === "own" && (
        <label className="field"><span className="label">{t("Your amount ($)")}</span>
          <input className="text-input donate-input" inputMode="numeric" value={own} placeholder="10" autoFocus
            onChange={(e) => { setErr(""); setOwn(e.target.value.split(/[.,]/)[0].replace(/\D/g, "").slice(0, 3)); }} data-testid="donate-own-input" /></label>
      )}
      {err && <div className="form-error" data-testid="donate-error">{err}</div>}
      <button type="button" className="primary-btn" onClick={give} disabled={busy} data-testid="donate-give-btn">
        {busy ? <Loader2 size={16} className="spin" /> : <Heart size={16} />}{t("Donate")}
      </button>
      <button type="button" className="ghost-btn donate-skip" onClick={onSkip} data-testid="donate-skip-btn">{t(skipLabel)}{!onSkipBack && <ArrowRight size={16} />}</button>
      <div className="scan-caution">{t("Secure checkout by Stripe. A thank-you email follows. Not a tax-deductible gift.")}</div>
    </div>
  );
}
